<template>
  <!-- toast -->
  <AlertMsg :msg="msgObj.msg" :show="msgObj.show" :role="msgObj.role" @closePopup="msgObj.show = false" />
  <!-- end toast -->
  <div class="row">
    <div class="col-12">
      <div class="d-flex align-items-center mt-3">
        <h5 class="mb-0 text-primary"><i class="far fa-calendar-plus text-primary"></i> Exam Timetable</h5>
      </div>
      <hr />
    <div class="col-md-4 d-flex align-items-center mb-2">
          <label class="form-label">Type<sup><span class="text-danger font-12 me-1">*</span></sup>: </label>
          <div class="dropdown w-100 ms-2">
            <button class="form-select form-select-sm rounded dropdown-toggle w-100 dropdown-a"
              type="button" data-bs-toggle="dropdown" aria-expanded="false"> {{ examType || " " }} </button>
            <ul class="dropdown-menu w-100 scrollable-menu">
              <li v-for="(item, index) in examList" :key="index">
                <a class="dropdown-item" href="#" @click.prevent="examType = item.Name"> {{ item.Name }} </a>
              </li>
            </ul>
          </div>
        </div>
        <ul v-if="errors.length" class="text-danger ps-3">
          <li v-for="(err, index) in errors" :key="index">{{ err }}</li>
        </ul>
        <hr>
        <div class="col-md-12 text-end">
        <i class="fas fa-print text-primary me-1" role="button" @click="printcontent('1')"></i>
        <i class="fas fa-download text-dark me-1" role="button" @click="downloadModalContent('1')"></i>
        <i class="fa fa-file-photo-o text-success" role="button" @click="downloadAsImage('1')"></i>
        </div>
      <div class="mb-4 mt-2">
        <div class="d-flex align-items-center mb-2">
          <label class="form-label me-2 mb-0">Title<sup><span class="text-danger font-12 me-1">*</span></sup>:</label>
          <input type="text" class="form-control form-control-sm ms-1" :value="formData.tbl1.Title"
            @input="formData.tbl1.Title = $event.target.value" />
        </div>
        <div class="d-flex align-items-center mb-2">
          <label class="form-label me-2 mb-0">Note<sup><span class="text-danger font-12 me-1">*</span></sup>:</label>
          <input type="text" class="form-control form-control-sm ms-1" :value="formData.tbl1.Note"  @input="formData.tbl1.Note = $event.target.value" />
        </div>
        <div class="table-responsive">
           <div class="progress mb-0 progress-sm" v-if="progress!=0">
        <div class="progress-bar" role="progressbar" :aria-valuenow="progress" aria-valuemin="0" aria-valuemax="100"
          :style="{ width: progress + '%' }"></div>
      </div>
        <table class="table table-striped table-bordered custom-table" v-if="progress==0">
          <thead>
            <tr>
              <th>Date</th>
              <th>Day</th>
              <th>Subject</th>
              <th style="width: 10%">Action</th>
            </tr>
          </thead>
          <tbody>
           <tr v-for="(item, index) in List.filter(item => item.positionID === '1' && item.examType === examType)" :key="'list1-' + index">
              <td>{{ disDate(item.examDate) }}</td>
              <td>{{ item.examDay }}</td>
              <td> {{ subList.find(sub => sub._id === item.subID)?.name || "N/A" }}</td>
              <td>
                <i class="fa fa-trash text-danger fs-5 mt-1 cursor-pointer" data-bs-toggle="modal"
                  data-bs-target="#standard-modal" role="button" @click="delID = item"> </i>
              </td>
            </tr>
            <tr>
              <td>
                  <input type="date" role="button" class="form-control form-control-sm cursor-pointer" v-model="formData.tbl1.examDate" @change="updateDay('tbl1')" />
              </td>
              <td>
               <input type="text" class="form-control form-control-sm" :value="formData.tbl1.examDay" readonly />
              </td>
              <td>
                 <div class="dropdown dropup w-100" data-bs-display="static">
                  <button class="form-select form-select-sm rounded dropdown-toggle w-100 dropdown-a" type="button" data-bs-toggle="dropdown" aria-expanded="false" >
                    {{ sortedSubList.find(sub => sub._id === formData.tbl1.subID)?.name || " " }}
                  </button>

                  <ul class="dropdown-menu w-100 scrollable-menu ">
                    <li v-for="(sub, index) in sortedSubList" :key="'sub-' + index">
                      <a class="dropdown-item" href="#" @click.prevent="formData.tbl1.subID = sub._id" >
                        {{ sub.name }}
                      </a>
                    </li>
                  </ul>
                </div>
              </td>
              <td>
                <i class="fa fa-save fs-4 mt-2 text-primary cursor-pointer" role="button" @click="save(formData.tbl1, '1')"></i>
              </td>
            </tr>
          </tbody>
        </table>
        </div>
      </div>
      <hr>
       <div class="col-md-12 text-end">
        <i class="fas fa-print text-primary me-1" role="button" @click="printcontent('2')"></i>
        <i class="fas fa-download text-dark me-1" role="button" @click="downloadModalContent('2')"></i>
        <i class="fa fa-file-photo-o text-success" role="button" @click="downloadAsImage('2')"></i>
        </div>
      <div class="mb-4 ">
        <div class="d-flex align-items-center mb-2">
          <label class="form-label me-2 mb-0">Title<sup><span class="text-danger font-12 me-1">*</span></sup>:</label>
          <input type="text" class="form-control form-control-sm ms-1" v-model="formData.tbl2.Title"  @input="formData.tbl2.Title = $event.target.value"/>
        </div>
        <div class="d-flex align-items-center mb-2">
          <label class="form-label me-2 mb-0">Note<sup><span class="text-danger font-12 me-1">*</span></sup>:</label>
          <input type="text" class="form-control form-control-sm ms-1" :value="formData.tbl2.Note" @input="formData.tbl2.Note = $event.target.value"/>
        </div>
        <div class="table-responsive">
        <table class="table table-striped table-bordered custom-table">
          <thead>
            <tr>
              <th>Date</th>
              <th>Day</th>
              <th>Subject</th>
              <th style="width: 10%">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in List.filter(item => item.positionID === '2' && item.examType === examType)" :key="'list2-' + index">
              <td>{{ disDate(item.examDate) }}</td>
              <td>{{ item.examDay }}</td>
              <td> {{ subList.find(sub => sub._id === item.subID)?.name || "N/A" }}</td>
              <td>
                <i class="fa fa-trash text-danger fs-5 mt-1 cursor-pointer" data-bs-toggle="modal"
                  data-bs-target="#standard-modal" role="button" @click="delID = item"> </i>
              </td>
            </tr>
            <tr>
              <td>
                  <input type="date" role="button" class="form-control form-control-sm cursor-pointer" v-model="formData.tbl2.examDate" @change="updateDay('tbl2')" />
              </td>
              <td>
               <input type="text" class="form-control form-control-sm" :value="formData.tbl2.examDay" readonly />
              </td>
              <td>
                <div class="dropdown dropup w-100" data-bs-display="static">
                  <button class="form-select form-select-sm rounded dropdown-toggle w-100 dropdown-a" type="button" data-bs-toggle="dropdown" aria-expanded="false" >
                    {{ sortedSubList.find(sub => sub._id === formData.tbl2.subID)?.name || " " }}
                  </button>

                  <ul class="dropdown-menu w-100 scrollable-menu ">
                    <li v-for="(sub, index) in sortedSubList" :key="'sub-' + index">
                      <a
                        class="dropdown-item"
                        href="#"
                        @click.prevent="formData.tbl2.subID = sub._id"
                      >
                        {{ sub.name }}
                      </a>
                    </li>
                  </ul>
                </div>
              </td>
              <td>
                <i class="fa fa-save text-primary fs-4 mt-2 cursor-pointer" role="button" @click="save(formData.tbl2, '2')"></i>
              </td>
            </tr>
          </tbody>
        </table>
        </div>
      </div>
      <hr>
      <div class="col-md-12 text-end">
        <i class="fas fa-print text-primary me-1" role="button" @click="printcontent('3')"></i>
        <i class="fas fa-download text-dark me-1" role="button" @click="downloadModalContent('3')"></i>
        <i class="fa fa-file-photo-o text-success" role="button" @click="downloadAsImage('3')"></i>
        </div>
      <div class="mb-4">
        <div class="d-flex align-items-center mb-2">
          <label class="form-label me-2 mb-0">Title<sup><span class="text-danger font-12 me-1">*</span></sup>:</label>
          <input type="text" class="form-control form-control-sm ms-1" v-model="formData.tbl3.Title" @input="formData.tbl3.Title = $event.target.value"/>
        </div>
        <div class="d-flex align-items-center mb-2">
          <label class="form-label me-2 mb-0">Note<sup><span class="text-danger font-12 me-1">*</span></sup>:</label>
          <input type="text" class="form-control form-control-sm ms-1" :value="formData.tbl3.Note" @input="formData.tbl3.Note = $event.target.value"/>
        </div>
        <div class="table-responsive">
        <table class="table table-bordered custom-table">
          <thead>
            <tr>
              <th>Date</th>
              <th>Day</th>
              <th>Subject</th>
              <th style="width: 10%">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in List.filter(item => item.positionID === '3' && item.examType === examType)" :key="'list3-' + index">
              <td>{{ disDate(item.examDate) }}</td>
              <td>{{ item.examDay }}</td>
              <td> {{ subList.find(sub => sub._id === item.subID)?.name || "N/A" }}</td>
              <td>
                <i class="fa fa-trash text-danger fs-5 mt-1 cursor-pointer" data-bs-toggle="modal"
                  data-bs-target="#standard-modal" role="button" @click="delID = item"> </i>
              </td>
            </tr>
            <tr>
              <td>
                  <input type="date" role="button" class="form-control form-control-sm cursor-pointer" v-model="formData.tbl3.examDate" @change="updateDay('tbl3')" />
              </td>
              <td>
               <input type="text" class="form-control form-control-sm" :value="formData.tbl3.examDay" readonly />
              </td>
              <td>
                 <div class="dropdown dropup w-100" data-bs-display="static">
                  <button class="form-select form-select-sm rounded dropdown-toggle w-100 dropdown-a" type="button" data-bs-toggle="dropdown" aria-expanded="false" >
                    {{ sortedSubList.find(sub => sub._id === formData.tbl3.subID)?.name || " " }}
                  </button>

                  <ul class="dropdown-menu w-100 scrollable-menu ">
                    <li v-for="(sub, index) in sortedSubList" :key="'sub-' + index">
                      <a class="dropdown-item" href="#" @click.prevent="formData.tbl3.subID = sub._id" >
                        {{ sub.name }}
                      </a>
                    </li>
                  </ul>
                </div>
              </td>
              <td>
                <i class="fa fa-save text-primary fs-4 mt-2 cursor-pointer" role="button" @click="save(formData.tbl3, '3')"></i>
              </td>
            </tr>
          </tbody>
        </table></div>
      </div>
      <hr>
        <div class="col-md-12 text-end">
        <i class="fas fa-print text-primary me-1" role="button" @click="printcontent('4')"></i>
        <i class="fas fa-download text-dark me-1" role="button" @click="downloadModalContent('4')"></i>
        <i class="fa fa-file-photo-o text-success" role="button" @click="downloadAsImage('4')"></i>
        </div>
      <div class="mb-4">
        <div class="d-flex align-items-center mb-2">
          <label class="form-label me-2 mb-0">Title<sup><span class="text-danger font-12 me-1">*</span></sup>:</label>
          <input type="text" class="form-control form-control-sm ms-1" v-model="formData.tbl4.Title" @input="formData.tbl4.Title = $event.target.value"/>
        </div>
        <div class="d-flex align-items-center mb-2">
          <label class="form-label me-2 mb-0">Note<sup><span class="text-danger font-12 me-1">*</span></sup>:</label>
          <input type="text" class="form-control form-control-sm ms-1" :value="formData.tbl4.Note" @input="formData.tbl4.Note = $event.target.value"/>
        </div>
        <div class="table-responsive">
        <table class="table table-bordered custom-table">
          <thead>
            <tr>
              <th>Date</th>
              <th>Day</th>
              <th>Subject</th>
              <th style="width: 10%">Action</th>
            </tr>
          </thead>
          <tbody>
           <tr v-for="(item, index) in List.filter(item => item.positionID === '4' && item.examType === examType)" :key="'list4-' + index">
              <td>{{ disDate(item.examDate) }}</td>
              <td>{{ item.examDay }}</td>
              <td> {{ subList.find(sub => sub._id === item.subID)?.name || "N/A" }}</td>
              <td>
                <i class="fa fa-trash text-danger fs-5 mt-1 cursor-pointer" data-bs-toggle="modal"
                  data-bs-target="#standard-modal" role="button" @click="delID = item"> </i>
              </td>
            </tr>
            <tr>
              <td>
                  <input type="date" role="button" class="form-control form-control-sm cursor-pointer" v-model="formData.tbl4.examDate" @change="updateDay('tbl4')" />
              </td>
              <td>
               <input type="text" class="form-control form-control-sm" :value="formData.tbl4.examDay" readonly />
              </td>
              <td>
                 <div class="dropdown dropup w-100" data-bs-display="static">
                  <button class="form-select form-select-sm rounded dropdown-toggle w-100 dropdown-a" type="button" data-bs-toggle="dropdown" aria-expanded="false" >
                    {{ sortedSubList.find(sub => sub._id === formData.tbl4.subID)?.name || " " }}
                  </button>

                  <ul class="dropdown-menu w-100 scrollable-menu ">
                    <li v-for="(sub, index) in sortedSubList" :key="'sub-' + index">
                      <a class="dropdown-item" href="#" @click.prevent="formData.tbl4.subID = sub._id" >
                        {{ sub.name }}
                      </a>
                    </li>
                  </ul>
                </div>
              </td>
              <td>
                <i class="fa fa-save text-primary fs-4 mt-2 cursor-pointer" role="button" @click="save(formData.tbl4, '4')"></i>
              </td>
            </tr>
          </tbody>
        </table></div>
      </div>
      <hr>
        <div class="col-md-12 text-end">
        <i class="fas fa-print text-primary me-1" role="button" @click="printcontent('5')"></i>
        <i class="fas fa-download text-dark me-1" role="button" @click="downloadModalContent('5')"></i>
        <i class="fa fa-file-photo-o text-success" role="button" @click="downloadAsImage('5')"></i>
        </div>
      <div class="mb-4">
        <div class="d-flex align-items-center mb-2">
          <label class="form-label me-2 mb-0">Title<sup><span class="text-danger font-12 me-1">*</span></sup>:</label>
          <input type="text" class="form-control form-control-sm ms-1" v-model="formData.tbl5.Title" @input="formData.tbl5.Title = $event.target.value"/>
        </div>
        <div class="d-flex align-items-center mb-2">
          <label class="form-label me-2 mb-0">Note<sup><span class="text-danger font-12 me-1">*</span></sup>:</label>
          <input type="text" class="form-control form-control-sm ms-1" :value="formData.tbl5.Note" @input="formData.tbl5.Note = $event.target.value"/>
        </div>
        <div class="table-responsive">
        <table class="table table-bordered custom-table">
          <thead>
            <tr>
              <th>Date</th>
              <th>Day</th>
              <th>Subject</th>
              <th style="width: 10%">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in List.filter(item => item.positionID === '5' && item.examType === examType)" :key="'list5-' + index">
              <td>{{ disDate(item.examDate) }}</td>
              <td>{{ item.examDay }}</td>
              <td> {{ subList.find(sub => sub._id === item.subID)?.name || "N/A" }}</td>
              <td>
                <i class="fa fa-trash text-danger fs-5 mt-1 cursor-pointer" data-bs-toggle="modal"
                  data-bs-target="#standard-modal" role="button" @click="delID = item"> </i>
              </td>
            </tr>
            <tr>
               <td>
                  <input type="date" role="button" class="form-control form-control-sm cursor-pointer" v-model="formData.tbl5.examDate" @change="updateDay('tbl5')" />
              </td>
              <td>
               <input type="text" class="form-control form-control-sm" :value="formData.tbl5.examDay" readonly />
              </td>
              <td>
                 <div class="dropdown dropup w-100" data-bs-display="static">
                  <button class="form-select form-select-sm rounded dropdown-toggle w-100 dropdown-a" type="button" data-bs-toggle="dropdown" aria-expanded="false" >
                    {{ sortedSubList.find(sub => sub._id === formData.tbl5.subID)?.name || " " }}
                  </button>

                  <ul class="dropdown-menu w-100 scrollable-menu ">
                    <li v-for="(sub, index) in sortedSubList" :key="'sub-' + index">
                      <a class="dropdown-item" href="#" @click.prevent="formData.tbl5.subID = sub._id" >
                        {{ sub.name }}
                      </a>
                    </li>
                  </ul>
                </div>
              </td>
              <td>
                <i class="fa fa-save text-primary fs-4 mt-2 cursor-pointer" role="button" @click="save(formData.tbl5, '5')"></i>
              </td>
            </tr>
          </tbody>
        </table>
        </div>
      </div>
      <hr>
        <div class="col-md-12 text-end">
        <i class="fas fa-print text-primary me-1" role="button" @click="printcontent('6')"></i>
        <i class="fas fa-download text-dark me-1" role="button" @click="downloadModalContent('6')"></i>
        <i class="fa fa-file-photo-o text-success" role="button" @click="downloadAsImage('6')"></i>
        </div>
      <div class="mb-4 ">
        <div class="d-flex align-items-center mb-2">
          <label class="form-label me-2 mb-0">Title<sup><span class="text-danger font-12 me-1">*</span></sup>:</label>
          <input type="text" class="form-control form-control-sm ms-1" v-model="formData.tbl6.Title" @input="formData.tbl6.Title = $event.target.value"/>
        </div>
        <div class="d-flex align-items-center mb-2">
          <label class="form-label me-2 mb-0">Note<sup><span class="text-danger font-12 me-1">*</span></sup>:</label>
          <input type="text" class="form-control form-control-sm ms-1" :value="formData.tbl6.Note" @input="formData.tbl6.Note = $event.target.value"/>
        </div>
        <div class="table-responsive">
        <table class="table table-bordered custom-table">
          <thead>
            <tr>
              <th>Date</th>
              <th>Day</th>
              <th>Subject</th>
              <th style="width: 10%">Action</th>
            </tr>
          </thead>
          <tbody>
           <tr v-for="(item, index) in List.filter(item => item.positionID === '6' && item.examType === examType)" :key="'list6-' + index">
              <td>{{ disDate(item.examDate) }}</td>
              <td>{{ item.examDay }}</td>
              <td> {{
                   subList.find(sub => sub._id === item.subID)?.name || "N/A"
                  }}</td>
              <td>
                <i class="fa fa-trash text-danger fs-5 mt-1 cursor-pointer" data-bs-toggle="modal"
                  data-bs-target="#standard-modal" role="button" @click="delID = item"> </i>
              </td>
            </tr>
            <tr>
               <td>
                  <input type="date" role="button" class="form-control form-control-sm cursor-pointer" v-model="formData.tbl6.examDate" @change="updateDay('tbl6')" />
              </td>
              <td>
               <input type="text" class="form-control form-control-sm" :value="formData.tbl6.examDay" readonly />
              </td>
              <td>
                  <div class="dropdown dropup w-100" data-bs-display="static">
                  <button class="form-select form-select-sm rounded dropdown-toggle w-100 dropdown-a" type="button" data-bs-toggle="dropdown" aria-expanded="false" >
                    {{ sortedSubList.find(sub => sub._id === formData.tbl6.subID)?.name || " " }}
                  </button>

                  <ul class="dropdown-menu w-100 scrollable-menu ">
                    <li v-for="(sub, index) in sortedSubList" :key="'sub-' + index">
                      <a class="dropdown-item" href="#" @click.prevent="formData.tbl6.subID = sub._id" >
                        {{ sub.name }}
                      </a>
                    </li>
                  </ul>
                </div>
              </td>
              <td>
                <i class="fa fa-save text-primary fs-4 mt-2 cursor-pointer" role="button" @click="save(formData.tbl6, '6')"></i>
              </td>
            </tr>
          </tbody>
        </table>
        </div>
      </div>
    </div>
  </div>
  <div ref="modalContent" class="invisible-content">
    <div class="card w-50">
          <div class="d-flex justify-content-center align-items-center text-center">
            <img :src="getUrl(profile && profile.Image)" alt="School Logo" class="me-2 mb-3 avatar-lg"/>
            <div class="me-5 mb-2">
              <h3 class="fw-bold mb-0 text-nowrap">{{ profile && profile.Name }}</h3>
              <p class="mb-0 small ">{{ profile && profile.Address }}</p>
              <p class="mb-0 small  ">{{ profile && profile.Email }}</p>
              <p class="mb-0 small ">+91 {{ profile && profile.MobileNo }}</p>
            </div>
          </div>
        <hr>
  <div class="mb-4 table-responsive me-4 mtt-5">
     <div class="text-center border border-secondary border-1 border-bottom-0 ">
      <span class="h-100 fs-6">{{getData(pos)?.examType }}</span>
    </div>
    <div class="text-center border border-secondary border-1 border-bottom-0 ">
      <span class="h-100 fs-6">{{ getData(pos)?.Title }}</span>
    </div>
    <table class="table table-bordered custom-table mb-2">
      <thead>
        <tr>
          <th>Date</th>
          <th>Day</th>
          <th>Subject</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in List.filter((item) => item.positionID === pos.toString() && item.examType === examType)" :key="'printlist'+pos+'-'+index">
          <td class="text-end">{{ disDate(item.examDate) }}</td>
          <td class="text-start">{{ item.examDay }}</td>
          <td class="text-center"> {{ subList.find(sub => sub._id === item.subID)?.name || "N/A" }}</td>
        </tr>
      </tbody>
    </table>
    <div class="d-flex align-items-center">
      <label class="form-label me-2 mb-1 fw-bold">Note :</label>
      <span class="border-0">{{ getData(pos)?.Note}}</span>
    </div>
  </div>
</div>
</div>
<DelPopup :name="delID?.examDay" @delRecord="delRecord" @closeModal="delID.examDay = ''" />
</template>
<script setup>
import AlertMsg from "@/components/Common/AlertMsg.vue";
import DelPopup from "@/components/Common/DelPopup.vue";
import { api, formatDate } from '@/utils/helpers.js';
import { isRequired, validateForm } from "@/utils/validation.js";
import { ref, onMounted,nextTick, watch, computed} from 'vue'
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { schoolStore } from '@/utils/schoolStore';
const {  examList, subList, profile } = schoolStore();
const modalContent = ref(null);
const examType = ref('');
const pos = ref('1');
 const newFields= () => { return { Title : "", examDate: "", examDay: "", examType: "",subID:"", Note : "", positionID: "" }; }
  const  formData = ref( { tbl1: newFields(), tbl2: newFields(), tbl3: newFields(), tbl4: newFields(), tbl5: newFields(),tbl6: newFields(), })
  const days= ref(["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"])
    const   msgObj= ref({ msg: "", role: "", show: false, })
    const   delID = ref({})
    const List=ref([])
   const errors = ref({})
const sortedSubList = computed(() => {
  const uniqueSubs = []
  const seen = new Set()
  for (const sub of subList.value) {
    const lowerName = sub.name.trim().toLowerCase()
    if (!seen.has(lowerName)) {
      seen.add(lowerName)
      uniqueSubs.push(sub)
    }
  }
  return uniqueSubs.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()))
})
const display = (selectedType) => {
  for (let i = 1; i <= 6; i++) {
    const filtered = List.value.filter(item => item.examType === selectedType && item.positionID === i.toString());
    const latest = filtered[filtered.length - 1]; 
    formData.value['tbl' + i].Title = latest?.Title || '';
    formData.value['tbl' + i].Note = latest?.Note || '';
  }
};
watch(examType, (newVal) => {
  display(newVal);
});
const save = async (Obj, positionID) => {
  const fields = {
    Title: { value: formData.value['tbl' + positionID].Title, validators: [isRequired], },
    Note: { value: formData.value['tbl' + positionID].Note, validators: [isRequired], },
    examType: { value: examType.value, validators: [isRequired], },
  };
  errors.value = validateForm(fields);
  if (Object.keys(errors.value).length === 0) {
    Obj['positionID'] = positionID;
    Obj['examType'] = examType.value;
    Obj['Title'] = formData.value['tbl' + positionID].Title;
    Obj['Note'] = formData.value['tbl' + positionID].Note;
    const isDuplicate = List.value.some(item =>
      item.examType === Obj.examType &&
      item.positionID === Obj.positionID &&
      item.subID === Obj.subID &&
      item.examDay === Obj.examDay
    );
    if (isDuplicate) {
      msgObj.value = { msg: "Exam TimeTable Already Exists", role: "danger", show: true, };
      return; 
    }

    try {
      const res= await api.post(`/examtbl/add`, Obj);
      msgObj.value = { msg: "Exam TimeTable Added Successfully.", role: "success", show: true, };
       if (res.status === 200) {
formData.value['tbl' + positionID] = { 
  Title: formData.value['tbl' + positionID].Title,
  Note: formData.value['tbl' + positionID].Note,
  examDate: '',
  examDay: '',
  examType: examType.value,
  subID: '',
  positionID
};

    }
      loadData();
    } catch (error) {
      console.error("Error saving data:", error);
    }
  } else {
    msgObj.value = { msg: "Please fill all required fields.", role: "danger", show: true, };
  }
};

const updateDay = (tblKey) => {
  const dateStr = formData.value[tblKey].examDate;
  if (!dateStr) return;
  const dateObj = new Date(dateStr);
  const dayName = days.value[dateObj.getDay() - 1] || "Sunday";
  formData.value[tblKey].examDay = dayName;
};
const disDate= (d)=> { return formatDate(d) }
    const delRecord= async() =>{
      if (!delID?.value._id) return;
      try {
        await api.delete(`/examtbl/${delID.value._id}`);
        msgObj.value = { msg: "ExamTimeTable Deleted Successfully.", role: "danger", show: true, };
        loadData();
      } catch (error) {
        console.error("Error deleting timetable record:", error);
      } finally {
        delID.value = {};
      }
    }
     const progress = ref(0)
    const loadData = async() => {
          let direction = 1
     let progressInterval = setInterval(() => {
       progress.value += direction
       if (progress.value >= 100) {
         progress.value = 0 
       }
     }, 100)
      await api .get(`/examtbl/all`)
        .then((response) => { List.value = response.data;
            progress.value = 0
          clearInterval(progressInterval)
         });
    }
 const getData = (positionID) => {
  const filtered = List.value.filter(item => item.positionID === positionID && item.examType === examType.value);
  const recent = filtered[filtered.length - 1]; 
  return {
    Title : recent?.Title || "N/A",
    Note : recent?.Note || "N/A",
    examType: recent?.examType || "N/A"
  };
};
 const printcontent = async (positionID) => {
  pos.value = positionID; 
  await nextTick();
      const printContent = modalContent.value?.innerHTML;
      const printWindow = window.open('', '', 'width=900,height=700');
      printWindow.document.write(`
      <html>
        <head>
          <style>
            body { font-family: Arial, sans-serif; padding: 20px; }
             .card { width: 90%; margin: auto; padding: 20px; border-radius:5px; }
            .border { border: 1px solid #ccc; }
            .border-bottom-0{border-bottom: 0px;}
            .p-2 { padding: 0.5rem; }
            .mb-0{margin-bottom:-10px;}
            .mb-1 { margin-bottom: 0.25rem; }
            .mb-2 { margin-bottom: 10px; }
            .mt-2{margin-top:15px;}
            .mtt-5{margin-top:40px;}
            .msl-5{margin-left:-100px;margin-top:-25px;}
            h3{font-size:35px; margin-top:-10px; margin-left:5px; white-space: wrap;}
            .text-end { text-align: end; }
            .fw-bold { font-weight: bold; }
            .text-center { text-align: center; }
            .text-muted { color: #6c757d; }
            .d-flex { display: flex; }
            .justify-content-between { justify-content: space-between; }
            .justify-content-end { justify-content: flex-end; }
            .align-items-center { align-items: center; }
            .w-100 { width: 100%; }
            .border-secondary { border-color: #ccc !important; }
            hr { margin: 1rem 0; }
            table { border-collapse: collapse; width: 100%; }
            th, td { border: 1px solid #ccc; padding: 8px; }
            img { max-width: 120px; height: 120px; margin-left:40px; }
            </style>
        </head>
        <body onload="window.print(); window.close();">
          ${printContent}
        </body>
      </html>
    `);
      printWindow.document.close();
    }
const downloadModalContent = async (positionID) => {
  pos.value = positionID;
  await nextTick();
  const modalElement = modalContent.value;
  if (!modalElement) return;
  try {
    const canvas = await html2canvas(modalElement, { scale: 4, useCORS: true });
    const imgData = canvas.toDataURL('image/png');
    const pdf = new jsPDF({ orientation: 'landscape', unit: 'px', format: [canvas.width, canvas.height] });
    pdf.addImage(imgData, 'PNG', 0, 0, canvas.width, canvas.height);
    pdf.save(`exam-timetable-${positionID}.pdf`);
  } catch (error) {
    console.error('Error generating PDF:', error);
  }
};
const downloadAsImage = async (positionID) => {
  pos.value = positionID;
  await nextTick();
  const element = modalContent.value;
  if (!element) return;
  const card = element.querySelector('.card');
  if (card) card.classList.add('force-full-width');
  try {
    const canvas = await html2canvas(element, { scale: 2, useCORS: true });
    const dataURL = canvas.toDataURL('image/jpeg', 1.0);
    const link = document.createElement('a');
    link.href = dataURL;
    link.download = `exam-timetable-${positionID}.jpg`;
    link.click();
  } catch (error) {
    console.error("Image download failed:", error);
  } finally {
    if (card) card.classList.remove('force-full-width');
  }
};
 const getUrl= (img)=> {
      let imgUrl = !img
        ? "/images/Logo.png"
        : img.startsWith("..")
          ? img.substring(2)
          : img;
      
  const base = process.env.VUE_APP_API_URL.replace(/\/+$/, "");
  const path = imgUrl.replace(/^\/+/, "");
  return `${base}/${path}`;
    }
  onMounted(async () => {
  await loadData();
  if (List.value.length > 0) {
    examType.value = List.value[0].examType;
    display(examType.value);
  }
});
</script>
<style>
.force-full-width {
  width: 100% !important;
}
.dropdown-menu {
  z-index: 9999 !important;
}
.dropup .dropdown-menu {
  bottom: 100%;
  top: auto !important;
  transform: translateY(-2px);
}

</style>
